import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { IAppConfig } from '../shared/interfaces/app-config';
import { AppConfigService } from './app-config.service';
import { EiAddStudent } from '../modules/ei-transition/models/ei-add-student.model';
import { EiSubmitStudent } from '../modules/ei-transition/models/ei-submit-student.model';
import { ApiResponse } from '../shared/interfaces/api-response';
import { CheckEI } from '../modules/ei-transition/interfaces/check-ei';
import { EIChildStatus } from '../modules/ei-transition/interfaces/request-new-document';
import { EIAutoEligibleCondition } from '../modules/ei-transition/interfaces/ei-auto-eligible-condition';

@Injectable({
  providedIn: 'root',
})
export class EITransitionService {
  config: IAppConfig;
  headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    accept: '*/*',
  });

  httpOptions: { headers: HttpHeaders } = {
    headers: this.headers,
  };

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  // TODO: Need to bring this up to Uday, the return type is not consistent from the backend. Following two different patterns.
  // Ideally, what should be returned is `ApiResponse<CheckEI>`
  checkEiId(eiId: string, agencyId: string): Observable<CheckEI> {
    return this.http
      .get<CheckEI>(
        `${this.config.apiUrl}/EITransition/checkEiIdExists/${eiId}/${agencyId}`
      )
      .pipe(catchError(this.handleError));
  }

  public CreateEI(eiData: EiSubmitStudent): Observable<ApiResponse<string>> {
    return this.http
      .post<ApiResponse<string>>(
        `${this.config.apiUrl}/EITransition`,
        eiData,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  // TODO: come back to this as I dont think this is the correct model being returned from the backend
  public GetEI(studentSk: string): Observable<EiAddStudent> {
    return this.http
      .get<EiAddStudent>(
        `${this.config.apiUrl}/EITransition/EI/${studentSk}`,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  public DeleteEI(studentSk: string): Observable<ApiResponse<string>> {
    return this.http
      .delete<ApiResponse<string>>(
        `${this.config.apiUrl}/EITransition/EI/${studentSk}`,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  public requestNewDocument(
    requestNewDocumentData: EIChildStatus
  ): Observable<ApiResponse<EIChildStatus>> {
    return this.http
      .put<ApiResponse<EIChildStatus>>(
        `${this.config.apiUrl}/EITransition/UpdateChildStatus`,
        requestNewDocumentData
      )
      .pipe(catchError(this.handleError));
  }

  getEIAutoEligibleConditions(): Observable<EIAutoEligibleCondition[]> {
    return this.http
      .get<EIAutoEligibleCondition[]>(
        `${this.config.apiUrl}/EITransition/GetEiAeConditions`,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  // Error handling
  handleError(error: any): Observable<never> {
    let errorMessage: string = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => {
      return errorMessage;
    });
  }
}
